module.exports = __webpack_public_path__ + "static/profile-eca24d61122872151fafdba11b2e4a90.jpg";